import setCSSVariable from './helpers/setCSSVariable';

class ProfetNavigation {
	constructor() {
		this.mobileMenuToggle = document.querySelector('.toggle-mobile-menu');
		this.desktopMenuToggle = document.querySelector('.toggle-desktop-menu');
		this.mobileMenuNavigation = document.querySelector('.header-mobile-nav-menu');
		this.mobileMenuNavigationItems = document.querySelectorAll('.header-mobile-nav-menu li a');
		this.mobileMenuVisible = false;
		this.desktopMenuVisible = false;
		this.headerDesktop = document.querySelector('#site-header-desktop');
		this.headerDesktopHeight = 0;
		this.headerMobile = document.querySelector('#site-header-mobile');
		this.closeNavigationMenu = document.querySelector('.close-navigation-menu');
		this.navigationOverlay = document.querySelector('.header-navigation-bg-overlay');
		this.dropdownArrows = [];
		this.variables = {
			scrollPosition: 0,
		};
		this.scrollLockPosition = 0; // This is the position the user was on when they were scroll locked. We want to be able to set them back to this position when we exit the scroll lock.
	}
	init() {
		if (!this.headerDesktop) {
			return;
		}

		/* Set CSS variables for the menu heights */
		document.documentElement.style.setProperty('--header_mobile_height', this.headerMobile.offsetHeight + 'px');
		document.documentElement.style.setProperty('--header_desktop_height', this.headerDesktop.offsetHeight + 'px');

		if (this.desktopMenuToggle) {
			this.desktopMenuToggle.addEventListener('click', (event) => {
				event.preventDefault();
				if (!this.desktopMenuVisible) {
					this.openDesktopNavigation();
				} else {
					this.closeDesktopNavigation();
				}
			});
		}

		if (this.mobileMenuToggle) {
			this.mobileMenuToggle.addEventListener('click', (event) => {
				event.preventDefault();
				if (!this.mobileMenuVisible) {
					this.openMobileNavigation();
				} else {
					this.closeMobileNavigation();
				}
			});
		}

		if (this.headerDesktop) {
			this.headerDesktopHeight = this.headerDesktop.offsetHeight;
		}

		if (this.closeNavigationMenu) {
			this.closeNavigationMenu.addEventListener('click', (event) => {
				event.preventDefault();
				document.querySelector('body').classList.remove('desktop-menu-open');
				document.querySelector('body').classList.remove('mobile-menu-open');
			});
		}

		if (this.navigationOverlay) {
			this.navigationOverlay.addEventListener('click', (event) => {
				event.preventDefault();
				document.querySelector('body').classList.remove('mobile-menu-open');
				document.querySelector('body').classList.remove('desktop-menu-open');
			});
		}
	}

	openMobileNavigation() {
		this.mobileMenuVisible = true;
		//this.handleScrollLock();
		document.querySelector('body').classList.add('mobile-menu-open');
	}
	closeMobileNavigation() {
		this.mobileMenuVisible = false;
		//this.handleScrollLock(true);
		document.querySelector('body').classList.remove('mobile-menu-open');
	}

	openDesktopNavigation() {
		this.desktopMenuVisible = true;
		//this.handleScrollLock();
		document.querySelector('body').classList.add('desktop-menu-open');
	}
	closeDesktopNavigation() {
		this.desktopMenuVisible = false;
		//this.handleScrollLock(true);
		document.querySelector('body').classList.remove('desktop-menu-open');
	}

	handleScrollLock(forceRemoveScrollLock) {
		if (document.querySelector('body').classList.contains('scroll-locked') || forceRemoveScrollLock) {
			document.querySelector('body').classList.remove('scroll-locked');
			window.scrollTo(0, this.scrollLockPosition); // values are x,y-offset
		} else {
			this.scrollLockPosition =
				window.pageYOffset !== undefined
					? window.pageYOffset
					: (document.documentElement || document.body.parentNode || document.body).scrollTop;
			window.setTimeout(function () {
				document.querySelector('body').classList.add('scroll-locked');
			}, 500);
		}
	}
}
window.addEventListener('load', () => {
	window.ProfetNavigation = new ProfetNavigation();
	window.ProfetNavigation.init();
});
